import { Button } from "@/components/ui/button";
import React from "react";
import Lottie from "react-lottie";
import animationData from "@/assets/tg_sticker/_DUCK17_CHMOKE_OUT_OUT.json";

interface SingleOnboardingPageProps {
  onNext?: () => void;
}

const SingleOnboardingPage: React.FC<SingleOnboardingPageProps> = ({ onNext }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="w-full sm:w-1/2 lg:w-1/3 p-4 flex flex-col h-full">
      <div className="flex flex-col items-center justify-center flex-grow">
        <div className="w-[60%] mb-10">
          <Lottie options={defaultOptions} />
        </div>
        <div className="text-xl font-semibold mb-10 text-center">
          <p>Train your AI agent to get paid for your data</p>
          <p>by fine-tuning business AI agents.</p>
          <br />
          <p>Join us in revolutionizing data ownership!</p>
        </div>
      </div>
      <div className="mt-auto">
        <Button
          onClick={onNext}
          size={"lg"}
          className="px-4 py-2 rounded-md w-full mx-auto block"
        >
          Get Started
        </Button>
      </div>
    </div>
  );
};

export default SingleOnboardingPage;